import { render, staticRenderFns } from "./AgencyTagsSettings.vue?vue&type=template&id=6292532c"
import script from "./AgencyTagsSettings.vue?vue&type=script&lang=ts"
export * from "./AgencyTagsSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports